import { APP_CONFIG } from "@/config/app-config";

const IS_DEV = APP_CONFIG.getCurrentEnvironment() === "development";

const ServiceLogger = {
  info(message: string) {
    if (!IS_DEV) return;

    console.info(`[Service Info]: ${message}\n`);
  },
  error(message: string, error?: Error) {
    if (!IS_DEV) return;

    console.error(`[Service Error]: ${message}.\n`);
    if (error) {
      console.error(`Error details: ${error.message || error}\n`);
    }
  },
  warn(message: string) {
    if (!IS_DEV) return;

    console.warn(`[Service Warning]: ${message}\n`);
  },
};

export { ServiceLogger };
